/** Formatos y etiquetas que comparten las pestañas de la ficha del cliente. */

export const dinero = (n, moneda = 'USD') =>
  `${moneda} ${Number(n || 0).toLocaleString('es-SV', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

/** Nombre del país a partir de su código ISO-2 («GT» → «Guatemala»). */
export const nombrePais = (iso) => {
  if (!iso) return '—'
  try {
    return new Intl.DisplayNames(['es'], { type: 'region' }).of(String(iso).toUpperCase()) || iso
  } catch {
    return iso
  }
}

export const fecha = (d) => (d ? new Date(d).toLocaleDateString('es-SV', { year: 'numeric', month: 'short', day: 'numeric' }) : '—')

// `aprobada` —el estado en el que queda una addenda cuando el dueño la firma— NO estaba en este
// mapa: la insignia salía con el texto crudo en gris, justo en el momento en que el asesor tiene
// que reconocer que ya puede aplicarla. Y «enviada» se etiquetaba «Esperando pago», que en un
// recorte es falso: no hay nada que pagar, se espera la ACEPTACIÓN del dueño.
/**
 * ¿La empresa es de modalidad nube pero todavía no tiene su espacio (tenant) creado? Es el estado
 * normal de una cotización PAGADA sin demo: el tenant nace al «Entregar a producción», no al pagar.
 * Mientras tanto no hay acceso del dueño, ni accesos por puesto, ni ocultación de áreas.
 */
export const sinEspacioNube = (ficha) =>
  (ficha?.modalidad || 'nube') === 'nube'
  && !ficha?.tenantId
  && !(ficha?.instancias || []).some((i) => i?.tenantId)

export const ESTADO_ADDENDA = {
  borrador: { label: 'Borrador', variant: 'secondary' },
  enviada: { label: 'Esperando al dueño', variant: 'warning' },
  aprobada: { label: 'Aceptada · lista para aplicar', variant: 'success' },
  pagada: { label: 'Pagada · lista para aplicar', variant: 'success' },
  aplicada: { label: 'Aplicada', variant: 'success' },
}

export const ESTADO_PLUGIN = {
  pending: { label: 'Pendiente', variant: 'warning' },
  reviewing: { label: 'En revisión', variant: 'secondary' },
  approved: { label: 'Aprobada', variant: 'success' },
  rejected: { label: 'Rechazada', variant: 'danger' },
  entregado: { label: 'Entregada', variant: 'success' },
}
